import { mergeRight } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {};

const feedBackReducerMap = {
	[types.FEED_BACK_OPEN]: (state, { payload: { taskTypeId, ...data } }) =>
		mergeRight(state, {
			[taskTypeId]: { open: true, ...data },
		}),
	[types.FEED_BACK_CLOSE]: (state, { payload }) =>
		mergeRight(state, {
			[payload]: {},
		}),
};

export default handleActions(feedBackReducerMap, initialState);
